
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.807 2.696c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0L10 1.502l2.5 2.5 1.307-1.306zm-1.974 1.973l-2.5-2.5-6.566 6.566a.327.327 0 00-.1.24v2.027a.33.33 0 00.333.333h2.027a.313.313 0 00.233-.1l6.573-6.566zm2.834 8.666H1.333c-.733 0-1.333.6-1.333 1.333S.6 16 1.333 16h13.334c.733 0 1.333-.6 1.333-1.333s-.6-1.333-1.333-1.333z","fill":"#2062F6"}})])
          )
        }
      }
    